<template>
  <div class="job-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Welcome' }">
            <i class="el-icon-s-home"></i> 首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <i class="el-icon-s-custom"></i> 组织管理
          </el-breadcrumb-item>
          <el-breadcrumb-item>岗位管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-icon icon-total">
          <i class="el-icon-s-custom"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">总岗位数</div>
          <div class="stat-number">{{ total }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon icon-active">
          <i class="el-icon-check"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">启用</div>
          <div class="stat-number">{{ activeCount }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon icon-inactive">
          <i class="el-icon-remove-outline"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">停用</div>
          <div class="stat-number">{{ inactiveCount }}</div>
        </div>
      </div>
    </div>

    <!-- 搜索筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-header">
        <i class="el-icon-search filter-icon"></i>
        <span class="filter-title">筛选查询</span>
      </div>
      <el-form size="small" :inline="true" :model="searchForm" ref="searchFormRef" class="filter-form">
        <div class="filter-row">
          <el-form-item label="岗位名称">
            <el-input v-model="searchForm.name" placeholder="请输入岗位名称" clearable prefix-icon="el-icon-s-custom"></el-input>
          </el-form-item>
          <el-form-item label="岗位编码">
            <el-input v-model="searchForm.code" placeholder="请输入岗位编码" clearable prefix-icon="el-icon-document"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable style="width: 200px;">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="停用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="action-buttons">
            <el-button type="primary" icon="el-icon-search" @click="searchSubmit" class="search-btn">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch" class="reset-btn">重置</el-button>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addData" class="add-btn">新增岗位</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-header-left">
          <i class="el-icon-s-data table-icon"></i>
          <span class="table-title">岗位列表</span>
          <el-tag type="info" size="small" effect="plain">共 {{ total }} 条记录</el-tag>
        </div>
        <div class="table-header-right">
          <el-tooltip content="刷新数据" placement="top">
            <el-button icon="el-icon-refresh" size="small" circle @click="getList"></el-button>
          </el-tooltip>
          <el-tooltip content="导出数据" placement="top">
            <el-button icon="el-icon-download" size="small" circle @click="handleExport"></el-button>
          </el-tooltip>
        </div>
      </div>

      <el-table
        :data="tableData"
        size="small"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        v-loading="loading"
        element-loading-text="数据加载中..."
        @sort-change="handleSortChange"
      >
        <el-table-column type="index" label="序号" width="60" align="center" fixed="left">
          <template slot-scope="scope">
            <span class="index-badge">{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="岗位名称" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="job-name">
              <i class="el-icon-s-custom"></i>
              <span class="name-text">{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="岗位编码" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag size="small" effect="plain" type="info">{{ scope.row.code }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="80" align="center">
          <template slot-scope="scope">
            <span class="sort-number">{{ scope.row.sort || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small" effect="plain">
              {{ scope.row.status === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="remark-text">{{ scope.row.remark || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" sortable="custom" prop="create_time">
          <template slot-scope="scope">
            <span class="time-text">{{ formatTime(scope.row.create_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button type="text" size="small" icon="el-icon-edit" @click="goEdit(scope.row)" class="edit-btn">编辑</el-button>
              <el-button type="text" size="small" icon="el-icon-delete" @click="handleDelete(scope.row)" class="delete-btn">删除</el-button>
              <el-dropdown trigger="click" size="small" @command="(command) => handleCommand(command, scope.row)">
                <span class="more-btn"><i class="el-icon-more"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-view" @click.native="goDetail(scope.row)" command="detail">查看详情</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.status === 1" icon="el-icon-remove" command="disable" divided>停用</el-dropdown-item>
                  <el-dropdown-item v-else icon="el-icon-check" command="enable" divided>启用</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        />
      </div>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false" @closed="handleDialogClosed" class="alipay-dialog">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px" size="small" label-position="right">
        <el-form-item label="岗位名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入岗位名称" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="岗位编码" prop="code">
          <el-input v-model="form.code" placeholder="请输入岗位编码（字母/数字/下划线）" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="999" controls-position="right" style="width: 100%;"></el-input-number>
          <div class="form-tip">数字越小，排序越靠前</div>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" maxlength="255" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitForm" size="small" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog title="岗位详情" :visible.sync="detailVisible" width="520px" class="alipay-dialog">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="岗位名称">{{ detailData.name }}</el-descriptions-item>
        <el-descriptions-item label="岗位编码">{{ detailData.code }}</el-descriptions-item>
        <el-descriptions-item label="排序">{{ detailData.sort || 0 }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="detailData.status === 1 ? 'success' : 'danger'" size="small" effect="plain">
            {{ detailData.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="备注">{{ detailData.remark || '--' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(detailData.create_time) }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 如果项目中没有 moment，可以使用原生方法
function formatTimestamp(timestamp) {
  if (!timestamp) return '--'
  const date = new Date(timestamp * 1000)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

// ---------- Mock API ----------
const mockApi = {
  getJobList(params) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let jobs = localStorage.getItem('job_mock_data')
        if (!jobs) {
          const now = Math.floor(Date.now() / 1000)
          const initData = [
            { id: 1, name: '产品经理', code: 'PM', sort: 1, status: 1, remark: '负责产品规划与设计', create_time: now - 86400 * 30, company_id: 1, is_del: 0 },
            { id: 2, name: '前端开发', code: 'FE', sort: 2, status: 1, remark: '负责前端界面开发', create_time: now - 86400 * 28, company_id: 1, is_del: 0 },
            { id: 3, name: '后端开发', code: 'BE', sort: 3, status: 1, remark: '负责后端服务开发', create_time: now - 86400 * 25, company_id: 1, is_del: 0 },
            { id: 4, name: 'UI设计师', code: 'UI', sort: 4, status: 0, remark: '负责界面视觉设计', create_time: now - 86400 * 20, company_id: 1, is_del: 0 },
            { id: 5, name: '测试工程师', code: 'QA', sort: 5, status: 1, remark: '负责质量保障', create_time: now - 86400 * 15, company_id: 1, is_del: 0 },
          ]
          localStorage.setItem('job_mock_data', JSON.stringify(initData))
          jobs = initData
        } else {
          jobs = JSON.parse(jobs)
        }

        let list = jobs.filter(item => item.is_del === 0 && item.company_id === (params.company_id || 1))
        if (params.name) list = list.filter(item => item.name.includes(params.name))
        if (params.code) list = list.filter(item => item.code && item.code.includes(params.code))
        if (params.status !== '' && params.status !== undefined && params.status !== null) {
          list = list.filter(item => item.status === params.status)
        }
        if (params.sortField && params.sortOrder) {
          list.sort((a, b) => {
            const aVal = a[params.sortField] || 0
            const bVal = b[params.sortField] || 0
            return params.sortOrder === 'ascending' ? aVal - bVal : bVal - aVal
          })
        } else {
          list.sort((a, b) => (a.sort || 0) - (b.sort || 0))
        }

        const total = list.length
        const start = (params.pageNum - 1) * params.pageSize
        const data = list.slice(start, start + params.pageSize)
        resolve({ code: 200, data, total, msg: 'success' })
      }, 300)
    })
  },
  addJob(data) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let jobs = localStorage.getItem('job_mock_data')
        jobs = jobs ? JSON.parse(jobs) : []
        const newId = jobs.length > 0 ? Math.max(...jobs.map(j => j.id)) + 1 : 1
        const newJob = { ...data, id: newId, is_del: 0, create_time: Math.floor(Date.now() / 1000) }
        jobs.push(newJob)
        localStorage.setItem('job_mock_data', JSON.stringify(jobs))
        resolve({ code: 200, msg: '添加成功', data: newJob })
      }, 300)
    })
  },
  updateJob(data) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let jobs = localStorage.getItem('job_mock_data')
        jobs = jobs ? JSON.parse(jobs) : []
        const index = jobs.findIndex(j => j.id === data.id)
        if (index !== -1) {
          jobs[index] = { ...jobs[index], ...data }
          localStorage.setItem('job_mock_data', JSON.stringify(jobs))
          resolve({ code: 200, msg: '更新成功' })
        } else {
          resolve({ code: 404, msg: '数据不存在' })
        }
      }, 300)
    })
  },
  deleteJob(id) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let jobs = localStorage.getItem('job_mock_data')
        jobs = jobs ? JSON.parse(jobs) : []
        const index = jobs.findIndex(j => j.id === id)
        if (index !== -1) {
          jobs[index].is_del = 1
          localStorage.setItem('job_mock_data', JSON.stringify(jobs))
          resolve({ code: 200, msg: '删除成功' })
        } else {
          resolve({ code: 404, msg: '数据不存在' })
        }
      }, 300)
    })
  },
  updateStatus(id, status) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let jobs = localStorage.getItem('job_mock_data')
        jobs = jobs ? JSON.parse(jobs) : []
        const index = jobs.findIndex(j => j.id === id)
        if (index !== -1) {
          jobs[index].status = status
          localStorage.setItem('job_mock_data', JSON.stringify(jobs))
          resolve({ code: 200, msg: '状态更新成功' })
        } else {
          resolve({ code: 404, msg: '数据不存在' })
        }
      }, 300)
    })
  }
}

export default {
  name: 'jobList',
  data() {
    const validateCode = (rule, value, callback) => {
      if (value && !/^[a-zA-Z0-9_]{2,20}$/.test(value)) {
        callback(new Error('岗位编码由字母、数字、下划线组成，2-20位'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      submitLoading: false,
      searchForm: { name: '', code: '', status: null },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      activeCount: 0,
      inactiveCount: 0,
      sortField: '',
      sortOrder: '',
      dialogVisible: false,
      dialogTitle: '',
      form: { id: null, name: '', code: '', sort: 0, status: 1, remark: '' },
      rules: {
        name: [{ required: true, message: '请输入岗位名称', trigger: 'blur' }, { max: 50, message: '不超过50个字符', trigger: 'blur' }],
        code: [{ required: true, message: '请输入岗位编码', trigger: 'blur' }, { validator: validateCode, trigger: 'blur' }],
        sort: [{ type: 'number', message: '排序必须为数字', trigger: 'blur' }]
      },
      detailVisible: false,
      detailData: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    formatTime(timestamp) {
      return formatTimestamp(timestamp)
    },
    async getList() {
      this.loading = true
      try {
        const companyId = sessionStorage.getItem('company_id') || 1
        const params = {
          company_id: companyId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm,
          sortField: this.sortField,
          sortOrder: this.sortOrder
        }
        const res = await mockApi.getJobList(params)
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.total
          // 统计启用/停用数量
          const allRes = await mockApi.getJobList({ company_id: companyId, pageNum: 1, pageSize: 999 })
          if (allRes.code === 200) {
            this.activeCount = allRes.data.filter(item => item.status === 1).length
            this.inactiveCount = allRes.data.filter(item => item.status === 0).length
          }
        } else {
          this.$message.error(res.msg || '数据加载失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('网络异常，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    searchSubmit() { this.pageNum = 1; this.getList() },
    resetSearch() { this.searchForm = { name: '', code: '', status: null }; this.pageNum = 1; this.getList() },
    handleSizeChange(newSize) { this.pageSize = newSize; this.pageNum = 1; this.getList() },
    handleCurrentChange(newPage) { this.pageNum = newPage; this.getList() },
    handleSortChange({ prop, order }) { if (prop === 'create_time') { this.sortField = 'create_time'; this.sortOrder = order; this.getList() } },
    addData() {
      this.dialogTitle = '新增岗位'
      this.form = { id: null, name: '', code: '', sort: 0, status: 1, remark: '' }
      this.dialogVisible = true
      this.$nextTick(() => { this.$refs.formRef?.clearValidate() })
    },
    goEdit(row) {
      this.dialogTitle = '编辑岗位'
      this.form = { ...row }
      this.dialogVisible = true
      this.$nextTick(() => { this.$refs.formRef?.clearValidate() })
    },
    goDetail(row) { this.detailData = { ...row }; this.detailVisible = true },
    async submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
          const company_id = sessionStorage.getItem('company_id') || 1
          const submitData = { ...this.form, company_id }
          let res
          if (this.form.id) res = await mockApi.updateJob(submitData)
          else res = await mockApi.addJob(submitData)
          if (res.code === 200) {
            this.$message.success(res.msg)
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('操作异常')
        } finally {
          this.submitLoading = false
        }
      })
    },
    handleDialogClosed() { this.$refs.formRef?.resetFields() },
    async handleDelete(row) {
      try {
        await this.$confirm(`确定要删除岗位"${row.name}"吗？删除后不可恢复。`, '提示', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', customClass: 'alipay-message-box'
        })
        const res = await mockApi.deleteJob(row.id)
        if (res.code === 200) {
          this.$message.success('删除成功')
          if (this.tableData.length === 1 && this.pageNum > 1) this.pageNum--
          this.getList()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) { /* 取消删除 */ }
    },
    async handleCommand(command, row) {
      switch (command) {
        case 'detail': this.goDetail(row); break
        case 'disable': await this.changeStatus(row, 0); break
        case 'enable': await this.changeStatus(row, 1); break
      }
    },
    async changeStatus(row, status) {
      const action = status === 1 ? '启用' : '停用'
      try {
        await this.$confirm(`确定要${action}岗位"${row.name}"吗？`, '提示', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', customClass: 'alipay-message-box'
        })
        const res = await mockApi.updateStatus(row.id, status)
        if (res.code === 200) { this.$message.success(`${action}成功`); this.getList() }
        else this.$message.error(res.msg || `${action}失败`)
      } catch (error) { /* 取消操作 */ }
    },
    handleExport() { this.$message.info('导出功能开发中，实际可调用后端导出接口') },
    tableRowClassName({ rowIndex }) { return rowIndex % 2 === 0 ? 'even-row' : 'odd-row' }
  }
}
</script>

<style lang="scss" scoped>
// 支付宝风格变量（与之前模块保持一致）
$primary-color: #1677ff;
$success-color: #00b42a;
$danger-color: #f53f3f;
$warning-color: #ff7d00;
$text-primary: #1f2d3d;
$text-regular: #4e5969;
$text-secondary: #86909c;
$border-color: #e5e6eb;
$bg-gray: #f7f8fa;
$card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);

.job-container {
  padding: 20px 24px;
  background: $bg-gray;
  min-height: calc(100vh - 84px);
}

/* 页面头部 */
.page-header {
  margin-bottom: 20px;
  .header-left .el-breadcrumb {
    margin-bottom: 12px;
    ::v-deep .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: $text-secondary;
        font-size: 13px;
        &.is-link {
          color: $primary-color;
          &:hover { color: lighten($primary-color, 10%); }
        }
      }
      &:last-child .el-breadcrumb__inner {
        color: $text-primary;
        font-weight: 500;
      }
    }
  }
}

/* 统计卡片 */
.stats-row {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  .stat-card {
    flex: 1;
    background: white;
    border-radius: 16px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: $card-shadow;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    &:hover {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
      border-color: rgba($primary-color, 0.1);
    }
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      &.icon-total { background: rgba($primary-color, 0.1); color: $primary-color; }
      &.icon-active { background: rgba($success-color, 0.1); color: $success-color; }
      &.icon-inactive { background: rgba($danger-color, 0.1); color: $danger-color; }
    }
    .stat-info {
      flex: 1;
      .stat-label { font-size: 13px; color: $text-secondary; margin-bottom: 4px; }
      .stat-number { font-size: 28px; font-weight: 600; color: $text-primary; line-height: 1.2; }
    }
  }
}

/* 筛选卡片 */
.filter-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body { padding: 20px 24px; }
  .filter-header {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid $border-color;
    .filter-icon { color: $primary-color; font-size: 18px; margin-right: 8px; }
    .filter-title { font-size: 15px; font-weight: 600; color: $text-primary; }
  }
  .filter-form {
    .filter-row {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      align-items: flex-end;
    }
    ::v-deep .el-form-item {
      margin-bottom: 0;
      .el-form-item__label { font-weight: 500; color: $text-regular; font-size: 13px; }
      .el-input__inner, .el-select .el-input__inner {
        border-radius: 8px;
        border-color: $border-color;
        &:focus {
          border-color: $primary-color;
          box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
        }
      }
    }
    .action-buttons {
      margin-left: auto;
      .search-btn, .reset-btn, .add-btn {
        border-radius: 20px;
        padding: 8px 20px;
        font-weight: 500;
      }
      .search-btn { background: $primary-color; border: none; &:hover { background: lighten($primary-color, 8%); } }
      .reset-btn { border-color: $border-color; color: $text-regular; &:hover { border-color: $primary-color; color: $primary-color; } }
      .add-btn { background: $primary-color; border: none; box-shadow: 0 2px 4px rgba(22,119,255,0.2); &:hover { background: lighten($primary-color, 8%); transform: translateY(-1px); } }
    }
  }
}

/* 表格卡片 */
.table-card {
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body { padding: 20px 24px; }
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid $border-color;
    .table-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
      .table-icon { color: $primary-color; font-size: 18px; }
      .table-title { font-size: 16px; font-weight: 600; color: $text-primary; }
      ::v-deep .el-tag { background: $bg-gray; border: none; color: $text-secondary; }
    }
    .table-header-right .el-button {
      color: $text-secondary;
      &:hover { color: $primary-color; background: rgba($primary-color,0.05); }
    }
  }
}

/* 表格样式 */
::v-deep .el-table {
  font-size: 13px;
  border-radius: 12px;
  overflow: hidden;
  th { background: $bg-gray !important; color: $text-secondary; font-weight: 500; padding: 12px 0; border-bottom: 1px solid $border-color; }
  td { padding: 14px 0; border-bottom: 1px solid $border-color; }
  .even-row { background: #ffffff; }
  .odd-row { background: #fbfbfc; }
  .hover-row > td { background: rgba($primary-color, 0.02) !important; }
  .el-table__sort-icon { color: $text-secondary; &.ascending, &.descending { color: $primary-color; } }
}

/* 单元格内容 */
.job-name {
  display: flex;
  align-items: center;
  gap: 8px;
  i { color: $primary-color; font-size: 16px; }
  .name-text { font-weight: 500; color: $text-primary; }
}
.sort-number {
  font-weight: 500;
  color: $warning-color;
}
.remark-text, .time-text { color: $text-secondary; font-size: 12px; }
.index-badge {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background: $bg-gray;
  color: $text-secondary;
  border-radius: 13px;
  font-size: 12px;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  .edit-btn { color: $primary-color; &:hover { background: rgba($primary-color,0.08); } }
  .delete-btn { color: $danger-color; &:hover { background: rgba($danger-color,0.08); } }
  .more-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 14px;
    cursor: pointer;
    color: $text-secondary;
    &:hover { background: rgba($text-secondary,0.1); color: $primary-color; }
    i { font-size: 16px; }
  }
}

/* 分页 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  margin-top: 16px;
  border-top: 1px solid $border-color;
  ::v-deep .el-pagination {
    .el-pagination__total, .el-pagination__jump { color: $text-secondary; font-size: 13px; }
    .btn-prev, .btn-next, .el-pager li { border-radius: 8px; margin: 0 4px; font-weight: 500; &:hover { color: $primary-color; } }
    .el-pager li.active { background: $primary-color; color: white; &:hover { background: lighten($primary-color,8%); } }
    .el-select .el-input__inner { border-radius: 8px; }
  }
}

/* 弹窗样式 */
::v-deep .alipay-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 35px -8px rgba(0,0,0,0.2);
    .el-dialog__header { border-bottom: 1px solid $border-color; padding: 20px 24px; .el-dialog__title { font-size: 18px; font-weight: 600; color: $text-primary; } }
    .el-dialog__body { padding: 24px; }
    .el-dialog__footer { border-top: 1px solid $border-color; padding: 16px 24px; }
  }
  .el-form-item__label { font-weight: 500; color: $text-regular; }
  .el-input__inner, .el-textarea__inner, .el-input-number__inner {
    border-radius: 8px;
    border-color: $border-color;
    &:focus {
      border-color: $primary-color;
      box-shadow: 0 0 0 2px rgba($primary-color,0.1);
    }
  }
  .el-radio__input.is-checked .el-radio__inner { background: $primary-color; border-color: $primary-color; }
  .el-descriptions {
    .el-descriptions__label { background: $bg-gray; color: $text-regular; font-weight: 500; width: 100px; }
    .el-descriptions__content { color: $text-primary; }
  }
  .form-tip {
    margin-top: 6px;
    font-size: 12px;
    color: $text-secondary;
    i { margin-right: 4px; color: $primary-color; }
  }
}

::v-deep .alipay-message-box {
  border-radius: 16px;
  .el-message-box__header { padding-top: 20px; .el-message-box__title { font-weight: 600; } }
  .el-message-box__btns button { border-radius: 20px; padding: 8px 20px; }
}

/* 响应式 */
@media (max-width: 1200px) {
  .stats-row { flex-direction: column; gap: 12px; .stat-card { padding: 16px 20px; } }
  .filter-form .filter-row {
    flex-direction: column;
    align-items: stretch;
    .el-form-item { width: 100%; }
    .action-buttons { margin-left: 0; display: flex; gap: 12px; .el-button { flex: 1; text-align: center; } }
  }
}
@media (max-width: 768px) {
  .job-container { padding: 16px; }
  .table-card ::v-deep .el-card__body { padding: 16px; }
  .action-buttons { flex-wrap: wrap; }
}
</style>